import { useState, useContext, useEffect } from "react"
import { Context } from "../../../utils/context"
import { authEndPoints } from "../../../utils/endpoints"
import useResponse from "../../useResponse"
import { parseJwt } from '../../../utils/config'

export default function useAuth() {
    const { axios, authData, setAuthData, resetAuth } = useContext(Context)
    const [response, setResponse] = useResponse()
    const [showPassword, setShowPassword] = useState(false)
    const [showToast, setShowToast] = useState(false)
    const [isAuthenticating, setIsAuthenticating] = useState(false)
    const [isUserAuthenticated, setIsUserAuthenticated] = useState(authData.exp && (new Date() < new Date(authData.exp * 1000)))
    useEffect(() => {
        setIsUserAuthenticated(authData.exp && (new Date() < new Date(authData.exp * 1000)))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authData])
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    }
    const handleToastClose = () => {
        setShowToast(false)
    }

    const authenticateUser = (data) => {
        resetAuth()
        setResponse({})
        setIsAuthenticating(true)
        axios.post(authEndPoints.login, data)
            .then(res => {
                if (res.status === 200) {
                    setShowToast(false)
                    const { data } = res.data
                    const decodedData = parseJwt(data.token)
                    decodedData.context = JSON.parse(decodedData.context)
                    setAuthData({
                        ...data,
                        ...decodedData
                    })
                }
                else setShowToast(true)
                setResponse(res.data)
            })
            .catch(err => console.log(err))
            .finally(() => setIsAuthenticating(false))
    }
    return {
        authenticateUser,
        response,
        isUserAuthenticated,
        showPassword,
        setShowPassword,
        handleMouseDownPassword,
        handleToastClose,
        showToast,
        isAuthenticating
    }
}